export default __webpack_public_path__ + "static/media/link.532dda72.svg";